import React from "react";
import PublicVehicle from "components/Tvendo/Distribution/DataMaster/PublicVehicle/List";

export default function () {
  return <PublicVehicle />;
}
